


export function InstrucoesAcabamento() {


    return (
        <div className="text-lg">
            <div ><span className="font-bold">1.</span> Consulte a escala de trabalho (gráfico gant), a área “Material para Acabamento” e, se necessário, o chefe do
                setor.</div>
            <hr className="mb-5" />
            <div><span className="font-bold">2.</span> Consulte dados das obras em APPRodrimaq&gt;Obras&gt;Data de entrega xxx&gt;Acabamentos.</div>
            <hr className="mb-5" />
            <div><span className="font-bold">3.</span> Proceda à intervenção necessária nas peças (polimento, retificação, furo, rosca, chanfros).</div>

            <hr className="mb-5" />
            <div ><span className="font-bold">4.</span>  Colocar na secção “Para Controlo” da estante do C&amp;Q, na respetiva caixa com a identificação da obra.</div>
            <hr className="mb-5" />
            <div className="mt-10"><span className="font-bold">Notas:</span> As peças NOK devem ser colocadas na caixa vermelha existente no setor. Tente, sempre que possível,
                manter o setor limpo e organizado.</div>
        </div>

    )

}